(function($) {
    $(() => {

        $('footer .accordion').click(function(){
            $(this).toggleClass('is-opened');
            $(this).next('.hidden-on-mobile').slideToggle();
        });
        
    });
})(jQuery);
